import React, { useMemo } from 'react';
import * as PropTypes from 'prop-types';

import Group from '../_Group';
import { extractRenderingContent } from '../inputSelectorsService';

import Checkbox from './Checkbox';

export default function CheckboxGroup({
  children: allChildren,
  optionValueKey = 'value',
  optionLabelKey = 'label',
  optionTitleKey = 'title',
  disabled = false,
  direction = 'row',
  ...restProps
}) {
  const children = useMemo(
    function() {
      return extractRenderingContent(allChildren, child => child?.type?.isCheckbox);
    },
    [allChildren]
  );
  return (
    <Group
      groupProps={{ optionValueKey, optionLabelKey, optionTitleKey, disabled, direction, ...restProps }}
      component={Checkbox}
    >
      {children}
    </Group>
  );
}

CheckboxGroup.propTypes = {
  options: PropTypes.array,
  checkedValues: PropTypes.oneOfType([PropTypes.array]),
  label: PropTypes.string,
  direction: PropTypes.string,
  optionValueKey: PropTypes.any,
  optionLabelKey: PropTypes.any,
  optionTitleKey: PropTypes.any,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string
};
